export const CREATE_PROPERTY_EVENT_REQUEST = "CREATE_PROPERTY_EVENT_REQUEST";
export const CREATE_PROPERTY_EVENT_SUCCESS = "CREATE_PROPERTY_EVENT_SUCCESS";
export const CREATE_PROPERTY_EVENT_FAILURE = "CREATE_PROPERTY_EVENT_FAILURE";


export const GET_PROPERTY_EVENTS_REQUEST = 'GET_PROPERTY_EVENTS_REQUEST';
export const GET_PROPERTY_EVENTS_SUCCESS = 'GET_PROPERTY_EVENTS_SUCCESS';
export const GET_PROPERTY_EVENTS_FAILURE = 'GET_PROPERTY_EVENTS_FAILURE';